// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Heading Auto-Numbering Extension
// Real-time decoration that prefixes H1/H2/H3 with section numbers
// ═══════════════════════════════════════════════════════════════

import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

export const HeadingNumbering = Extension.create({
  name: 'headingNumbering',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('headingNumbering'),
        props: {
          decorations(state) {
            const decorations: Decoration[] = [];
            const counters = [0, 0, 0];

            state.doc.descendants((node, pos) => {
              if (node.type.name === 'heading') {
                const level = node.attrs.level as number;

                if (level === 1) {
                  counters[0]++;
                  counters[1] = 0;
                  counters[2] = 0;
                } else if (level === 2) {
                  counters[1]++;
                  counters[2] = 0;
                } else if (level === 3) {
                  counters[2]++;
                }

                // Only number H1–H3
                if (level > 3) return;

                const num =
                  level === 1
                    ? `${counters[0]}. `
                    : level === 2
                      ? `${counters[0]}.${counters[1]}. `
                      : `${counters[0]}.${counters[1]}.${counters[2]}. `;

                decorations.push(
                  Decoration.widget(
                    pos + 1,
                    () => {
                      const span = document.createElement('span');
                      span.textContent = num;
                      span.className = 'heading-number';
                      span.style.cssText =
                        'font-weight:inherit;color:inherit;user-select:none;pointer-events:none;';
                      span.contentEditable = 'false';
                      return span;
                    },
                    { side: -1 },
                  ),
                );
              }
            });

            return DecorationSet.create(state.doc, decorations);
          },
        },
      }),
    ];
  },
});
